import Commons from "oc-commons/Commons";

/**
 * Statische Utility-Klasse zum Thema Url, Location und Browser-History
 */
export default class Urls {

    static getParameters() {
        return ('' + location.search).split(/[\\?&]/).filter(x => x != '').map((pair) => pair.split('=').map(Urls.urldecode));
    }

    /**
     * Gibt den Wert eines Url-Parameters zurück
     * @param {string} key
     */
    static urlParam(key) {
        return Urls.urlParamFromSearch(window.location.search, key);
    }

    /**
     * Gibt den Wert eines Url-Parameters URLDecodiert zurück
     * @param {string} key
     */
    static urlParamWithDecoding(key) {
        return decodeURIComponent(Urls.urlParamFromSearch(window.location.search, key));
    }

    /**
     * @param {string} search
     * @param {string} key
     */
    static urlParamFromSearch(search, key) {
        const parts = search.substring(1).split('#')[0].split('&');
        for (let i = 0; i < parts.length; i++) {
            const keyValue = parts[i].split('=');
            if (keyValue[0] == key) {
                return keyValue.length == 1 ? true : Urls.urldecode(keyValue[1]);
            }
        }
    }

    /**
     * sicheres urldecode mit ersetzen aller + durch %20
     * @param {?any} str
     */
    static urldecode(str) {
        return decodeURIComponent((str + '').replace(/\+/g, '%20'));
    }


    /**
     * CORS safe Iframe helper
     * @returns {string}
     */
    static getParentUrl() {
        if (window == parent.window) {
            return window.location.href;
        }
        return document.referrer;
    }

    static getQS(url) {
        let result = '';
        const idx = url.indexOf('?');
        if (idx >= 0) {
            result = url.substring(idx);
        }
        return result;
    }

    /**
     * lädt eine URL als neue location.href und fügt sie zur History ein
     * @param {string} url
     */
    static loadAndPushLocation(url) {
        if (window.history) {
            window.history.pushState({page: window.location.href}, window.location.href);
        }
        window.location.href = url;
    }

    /**
     *
     */
    static() {
        window.history.replaceState({}, '', '?q=' + v + window.location.hash);
    }

    /**
     * Fügt einen Querystring-Teil zu einer übergebenen url hinzu und achtet darauf,
     * ob in der Url bereits ein Fragezeichen verwendet wurde
     * @example
     * addQsPart('preview.objectcode.de?sing=song','?Code=#ghjkkl&Auch=soundso')
     * => preview.objectcode.de?sing=song&Code=#ghjkkl&Auch=soundso
     * @param {?string} url
     * @param {?any} part
     */
    static addQsPart(url, part, acceptNoThirdParameter) {
        if (acceptNoThirdParameter !== undefined) {
            throw 'Urls.addQsPart does not accept a third parameter. If you want to add a key and a value use Urls.addOrUpdateQsParameter';
        }
        url = url == null ? '' : url;
        part = part == null ? '' : part;
        part = part.replace('?', '&');
        if (part.startsWith('&')) {
            part = part.substring(1);
        }
        const hasQS = url.indexOf('?') >= 0;
        return url + (hasQS ? '&' : '?') + part;
    }

    /**
     * Fügt/aktualisiert einen Parameter zu einer übergebenen url hinzu
     * @example
     * addOrUpdateQsParameter('preview.objectcode.de?sing=song','Code','#ghjkkl)
     * liefert preview.objectcode.de?sing=song&Code=#ghjkkl
     * @param {?string} url
     * @param {?any} key
     * @param {?any} value
     * @returns {string}
     */
    static addOrUpdateQsParameter(url, key, value) {
        const {protocol, server, path, keyValues, hashPart} = Urls.urlSplit(url);
        const index = keyValues.findIndex(kv => kv[0] == key);
        if (index == -1) {
            if (value === undefined) {
                keyValues.push([key]);
            } else {
                keyValues.push([key, value]);
            }
        } else {
            keyValues[index][1] = value;
        }
        return Urls.urlJoin({protocol, server, path, keyValues, hashPart});
    }

    /**
     * Fügt/aktualisiert einen Parameter zu einer übergebenen url hinzu und URLencodiert alle Parameter
     * @example
     * addOrUpdateQsParameterWithUrlEncoding('preview.objectcode.de?sing=song','Code','#ghjkkl)
     * liefert preview.objectcode.de?sing=song&Code=#ghjkkl
     * @param {?string} url
     * @param {?any} key
     * @param {?any} value
     * @returns {string}
     */
    static addOrUpdateQsParameterWithUrlEncoding(url, key, value) {
        const {protocol, server, path, keyValues, hashPart} = Urls.urlSplit(url);
        const index = keyValues.findIndex(kv => kv[0] == key);
        if (index == -1) {
            if (value === undefined) {
                keyValues.push([key]);
            } else {
                keyValues.push([key, encodeURIComponent(value)]);
            }
        } else {
            keyValues[index][1] = encodeURIComponent(value);
        }
        return Urls.urlJoin({protocol, server, path, keyValues, hashPart});
    }


    /**
     * teilt eine URL in ihre Bestandteile.
     * Beispiel:
     * const {protocol,server,path,keyValues,hashPart} = Urls.urlSplit("http://example.de/configurator/start?a=b&c=d&e#123");
     * // protocol = 'http'
     * // server = 'example.de'
     * // path = '/configurator/start'
     * // keyValues = [[a,b],[c,d],[e]]
     * // hashPart = '#123'
     */
    static urlSplit(url) {
        const hasQS = url.indexOf('?') >= 0;
        const hasHashPart = url.indexOf('#') >= 0;
        const hashPart = hasHashPart ? url.substring(url.indexOf('#')) : '';
        if (hasHashPart) {
            url = url.substring(0, url.indexOf('#'));
        }
        let base = hasQS ? (url.substr(0, url.indexOf('?'))) : url;
        const kvp = hasQS ? url.substr(url.indexOf('?') + 1).split('&') : [];
        const keyValues = [];
        let i = kvp.length;
        while (i--) {
            if (kvp[i] == '') {
                continue;
            }
            const splitter = kvp[i].indexOf("=");
            keyValues.push([kvp[i].substr(0, splitter), kvp[i].substr(splitter+1)]);
        }
        const protparts = base.split('://', 2);
        let protocol = '';
        if (protparts.length == 2) {
            protocol = protparts[0];
            base = protparts[1];
        }
        const slashIndex = base.indexOf('/');
        const server = base.substring(0, slashIndex);
        const path = base.substring(slashIndex);
        return {protocol, server, path, keyValues, hashPart};
    }

    /**
     * Fügt die Bestandteile einer URL wieder zusammen, Umkehrfunktion zu urlSplit
     */
    static urlJoin({protocol, server, path, keyValues, hashPart}) {
        let url = '';
        if (!Commons.isEmpty(protocol)) {
            url += protocol + '://';
        }
        return url + server + path + (keyValues.length === 0 ? '' : '?') + keyValues.map(kv => kv.join('=')).join('&') + hashPart;
        ;
    }

    /**
     * prüft, ob die url absolut ist
     * @param {?string} url
     * @returns {boolean}
     */
    static isAbsolute(url) {
        return /^http(s?):\/\//i.test(url);
    }

}
